import { render, staticRenderFns } from "./LodomelixTestRegistration.vue?vue&type=template&id=45f10e31"
import script from "./LodomelixTestRegistration.vue?vue&type=script&lang=js"
export * from "./LodomelixTestRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports